var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("FormSubmitPopup", {
        ref: "formPopup",
        attrs: {
          title: _vm.title,
          rightMethod: _vm.onSubmitted,
          rightButtonText: _vm.$t("confirm"),
          hasAlert: "",
          large: ""
        },
        on: {
          popupClose: function($event) {
            return _vm.$emit("input", false)
          }
        },
        scopedSlots: _vm._u([
          {
            key: "input",
            fn: function() {
              return [
                _c(
                  "v-container",
                  { attrs: { "py-0": "", fluid: "" } },
                  [
                    _c(
                      "v-layout",
                      { attrs: { row: "" } },
                      [
                        _c(
                          "v-flex",
                          { attrs: { xs12: "" } },
                          [
                            _c(
                              "v-card",
                              {
                                staticClass: "template-header-card",
                                attrs: { width: "100%" }
                              },
                              [
                                _c(
                                  "v-card-text",
                                  [
                                    _c(
                                      "v-layout",
                                      {
                                        attrs: {
                                          "align-baseline": "",
                                          "justify-space-between": "",
                                          wrap: ""
                                        }
                                      },
                                      [
                                        _c(
                                          "v-flex",
                                          {
                                            staticClass: "title",
                                            attrs: { md2: "" }
                                          },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(_vm.$t("templateInfo")) +
                                                ":\n                "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-flex",
                                          { attrs: { md10: "" } },
                                          [
                                            _c(
                                              "v-layout",
                                              {
                                                attrs: {
                                                  "justify-space-between": "",
                                                  wrap: ""
                                                }
                                              },
                                              [
                                                _c(
                                                  "v-flex",
                                                  {
                                                    attrs: { md3: "", xs12: "" }
                                                  },
                                                  [
                                                    _c("v-text-field", {
                                                      staticClass:
                                                        "required_field",
                                                      attrs: {
                                                        "hide-details": "",
                                                        label: _vm.$t(
                                                          "templateName"
                                                        ),
                                                        rules: [
                                                          _vm.fieldIsRequired(
                                                            "template"
                                                          )
                                                        ]
                                                      },
                                                      model: {
                                                        value: _vm.name,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.name =
                                                            typeof $$v ===
                                                            "string"
                                                              ? $$v.trim()
                                                              : $$v
                                                        },
                                                        expression: "name"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "v-flex",
                                                  {
                                                    attrs: { md3: "", xs12: "" }
                                                  },
                                                  [
                                                    _c("v-autocomplete", {
                                                      staticClass: "ml-3",
                                                      attrs: {
                                                        "hide-details": "",
                                                        items:
                                                          _vm.businessTypeOptions,
                                                        "item-text": "text",
                                                        "item-value": "value",
                                                        label: _vm.$t(
                                                          "shippingType"
                                                        ),
                                                        rules: [
                                                          _vm.fieldIsRequired(
                                                            "shipping type"
                                                          )
                                                        ]
                                                      },
                                                      model: {
                                                        value: _vm.businessType,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.businessType = $$v
                                                        },
                                                        expression:
                                                          "businessType"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "v-flex",
                                                  {
                                                    attrs: { md6: "", xs12: "" }
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "template-header-hint"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "templateApplyDescription"
                                                            )
                                                          )
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-layout",
                      { attrs: { row: "" } },
                      [
                        _c(
                          "v-flex",
                          { attrs: { md6: "" } },
                          [
                            _c(
                              "v-card",
                              { attrs: { width: "100%" } },
                              [
                                _c(
                                  "v-card-text",
                                  [
                                    _c(
                                      "v-layout",
                                      { attrs: { "align-baseline": "" } },
                                      [
                                        _c(
                                          "v-flex",
                                          {
                                            staticClass: "title",
                                            attrs: { md3: "" }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("sender")) + ": "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-flex",
                                          { attrs: { md4: "" } },
                                          [
                                            _c("vite-autocomplete", {
                                              attrs: {
                                                "hide-details": "",
                                                items: _vm.addresses,
                                                "return-object": "",
                                                label: _vm.$t("addressName"),
                                                "item-text": "siteName",
                                                "item-value": "siteName"
                                              },
                                              model: {
                                                value: _vm.fromTemplate,
                                                callback: function($$v) {
                                                  _vm.fromTemplate = $$v
                                                },
                                                expression: "fromTemplate"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-layout",
                                      {
                                        attrs: { "justify-space-between": "" }
                                      },
                                      [
                                        _c(
                                          "v-flex",
                                          { attrs: { xs7: "" } },
                                          [
                                            _c(
                                              "v-layout",
                                              {
                                                attrs: {
                                                  "justify-space-between": ""
                                                }
                                              },
                                              [
                                                _c(
                                                  "v-flex",
                                                  { attrs: { xs5: "" } },
                                                  [
                                                    _c("v-text-field", {
                                                      attrs: {
                                                        "hide-details": "",
                                                        label: _vm.$t(
                                                          "fullName"
                                                        ),
                                                        rules: [
                                                          _vm.fieldIsRequired(
                                                            "Full name"
                                                          ),
                                                          _vm.fieldCharLimit(
                                                            "Sender name",
                                                            35
                                                          )
                                                        ]
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.from.fullName,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.from,
                                                            "fullName",
                                                            typeof $$v ===
                                                              "string"
                                                              ? $$v.trim()
                                                              : $$v
                                                          )
                                                        },
                                                        expression:
                                                          "from.fullName"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "v-flex",
                                                  { attrs: { xs5: "" } },
                                                  [
                                                    _c("v-text-field", {
                                                      attrs: {
                                                        "hide-details": "",
                                                        label: _vm.$t("phone")
                                                      },
                                                      model: {
                                                        value: _vm.from.phone,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.from,
                                                            "phone",
                                                            typeof $$v ===
                                                              "string"
                                                              ? $$v.trim()
                                                              : $$v
                                                          )
                                                        },
                                                        expression: "from.phone"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-flex",
                                          { attrs: { xs4: "" } },
                                          [
                                            _c("v-text-field", {
                                              attrs: {
                                                "hide-details": "",
                                                label: _vm.$t("companyName")
                                              },
                                              model: {
                                                value: _vm.from.company,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.from,
                                                    "company",
                                                    typeof $$v === "string"
                                                      ? $$v.trim()
                                                      : $$v
                                                  )
                                                },
                                                expression: "from.company"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-layout",
                                      {
                                        attrs: { "justify-space-between": "" }
                                      },
                                      [
                                        _c(
                                          "v-flex",
                                          { attrs: { xs7: "" } },
                                          [
                                            _c("v-text-field", {
                                              attrs: {
                                                "hide-details": "",
                                                label: _vm.$t("address") + " 1",
                                                rules: [
                                                  _vm.fieldIsRequired(
                                                    "Address"
                                                  ),
                                                  _vm.fieldCharLimit(
                                                    "Address1",
                                                    50
                                                  )
                                                ]
                                              },
                                              model: {
                                                value: _vm.from.address1,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.from,
                                                    "address1",
                                                    typeof $$v === "string"
                                                      ? $$v.trim()
                                                      : $$v
                                                  )
                                                },
                                                expression: "from.address1"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-flex",
                                          { attrs: { xs4: "" } },
                                          [
                                            _c("v-text-field", {
                                              attrs: {
                                                "hide-details": "",
                                                label: _vm.$t("address") + " 2",
                                                rules: [
                                                  _vm.fieldCharLimit(
                                                    "Address2",
                                                    50
                                                  )
                                                ]
                                              },
                                              model: {
                                                value: _vm.from.address2,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.from,
                                                    "address2",
                                                    typeof $$v === "string"
                                                      ? $$v.trim()
                                                      : $$v
                                                  )
                                                },
                                                expression: "from.address2"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-layout",
                                      {
                                        attrs: { "justify-space-between": "" }
                                      },
                                      [
                                        _c(
                                          "v-flex",
                                          { attrs: { xs7: "" } },
                                          [
                                            _c(
                                              "v-layout",
                                              {
                                                attrs: {
                                                  "justify-space-between": ""
                                                }
                                              },
                                              [
                                                _c(
                                                  "v-flex",
                                                  { attrs: { xs5: "" } },
                                                  [
                                                    _c("v-text-field", {
                                                      attrs: {
                                                        "hide-details": "",
                                                        label: _vm.$t("city"),
                                                        rules: [
                                                          _vm.fieldIsRequired(
                                                            "City"
                                                          )
                                                        ]
                                                      },
                                                      model: {
                                                        value: _vm.from.city,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.from,
                                                            "city",
                                                            typeof $$v ===
                                                              "string"
                                                              ? $$v.trim()
                                                              : $$v
                                                          )
                                                        },
                                                        expression: "from.city"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "v-flex",
                                                  { attrs: { xs5: "" } },
                                                  [
                                                    _vm.fromStateOptions.length
                                                      ? _c("v-autocomplete", {
                                                          attrs: {
                                                            "hide-details": "",
                                                            items:
                                                              _vm.fromStateOptions,
                                                            label: _vm.$t(
                                                              "state"
                                                            ),
                                                            rules:
                                                              _vm.fromStateRules
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.from.state,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.from,
                                                                "state",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "from.state"
                                                          }
                                                        })
                                                      : _c("v-text-field", {
                                                          attrs: {
                                                            "hide-details": "",
                                                            label: _vm.$t(
                                                              "state"
                                                            ),
                                                            rules:
                                                              _vm.fromStateRules
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.from.state,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.from,
                                                                "state",
                                                                typeof $$v ===
                                                                  "string"
                                                                  ? $$v.trim()
                                                                  : $$v
                                                              )
                                                            },
                                                            expression:
                                                              "from.state"
                                                          }
                                                        })
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-flex",
                                          { attrs: { xs4: "" } },
                                          [
                                            _c("v-text-field", {
                                              attrs: {
                                                "hide-details": "",
                                                label: _vm.$t("zipCode"),
                                                rules: [
                                                  _vm.fieldIsRequired(
                                                    "Zip code"
                                                  ),
                                                  function(v) {
                                                    return _vm.validateZipCodeBasic(
                                                      v,
                                                      _vm.from.countryCode
                                                    )
                                                  }
                                                ]
                                              },
                                              model: {
                                                value: _vm.from.zipCode,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.from,
                                                    "zipCode",
                                                    typeof $$v === "string"
                                                      ? $$v.trim()
                                                      : $$v
                                                  )
                                                },
                                                expression: "from.zipCode"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-layout",
                                      {
                                        attrs: { "justify-space-between": "" }
                                      },
                                      [
                                        _c(
                                          "v-flex",
                                          { attrs: { xs7: "" } },
                                          [
                                            _c("v-text-field", {
                                              attrs: {
                                                "hide-details": "",
                                                label: _vm.$t("email"),
                                                rules: [
                                                  function(v) {
                                                    return (
                                                      !v ||
                                                      _vm.fieldIsEmail()(v)
                                                    )
                                                  }
                                                ]
                                              },
                                              model: {
                                                value: _vm.from.email,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.from,
                                                    "email",
                                                    typeof $$v === "string"
                                                      ? $$v.trim()
                                                      : $$v
                                                  )
                                                },
                                                expression: "from.email"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-flex",
                                          { attrs: { xs4: "" } },
                                          [
                                            _c("v-autocomplete", {
                                              attrs: {
                                                "hide-details": "",
                                                items: _vm.fromCountryOptions,
                                                "item-text": "name",
                                                "item-value": "value",
                                                label: _vm.$t("country"),
                                                rules: _vm.fromCountryRules
                                              },
                                              model: {
                                                value: _vm.from.countryCode,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.from,
                                                    "countryCode",
                                                    $$v
                                                  )
                                                },
                                                expression: "from.countryCode"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-flex",
                          { attrs: { md6: "" } },
                          [
                            _c(
                              "v-card",
                              { attrs: { width: "100%" } },
                              [
                                _c(
                                  "v-card-text",
                                  [
                                    _c(
                                      "v-layout",
                                      { attrs: { "align-baseline": "" } },
                                      [
                                        _c(
                                          "v-flex",
                                          {
                                            staticClass: "title",
                                            attrs: { md3: "" }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("recipient")) + ": "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-flex",
                                          { attrs: { md4: "" } },
                                          [
                                            _c("vite-autocomplete", {
                                              attrs: {
                                                "hide-details": "",
                                                items: _vm.addresses,
                                                "return-object": "",
                                                label: _vm.$t("addressName"),
                                                "item-text": "siteName",
                                                "item-value": "siteName"
                                              },
                                              model: {
                                                value: _vm.toTemplate,
                                                callback: function($$v) {
                                                  _vm.toTemplate = $$v
                                                },
                                                expression: "toTemplate"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-layout",
                                      {
                                        attrs: { "justify-space-between": "" }
                                      },
                                      [
                                        _c(
                                          "v-flex",
                                          { attrs: { xs7: "" } },
                                          [
                                            _c(
                                              "v-layout",
                                              {
                                                attrs: {
                                                  "justify-space-between": ""
                                                }
                                              },
                                              [
                                                _c(
                                                  "v-flex",
                                                  { attrs: { xs5: "" } },
                                                  [
                                                    _c("v-text-field", {
                                                      attrs: {
                                                        "hide-details": "",
                                                        label: _vm.$t(
                                                          "fullName"
                                                        ),
                                                        rules: [
                                                          _vm.fieldIsRequired(
                                                            "Full name"
                                                          ),
                                                          _vm.fieldCharLimit(
                                                            "Full name",
                                                            35
                                                          )
                                                        ]
                                                      },
                                                      model: {
                                                        value: _vm.to.fullName,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.to,
                                                            "fullName",
                                                            typeof $$v ===
                                                              "string"
                                                              ? $$v.trim()
                                                              : $$v
                                                          )
                                                        },
                                                        expression:
                                                          "to.fullName"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "v-flex",
                                                  { attrs: { xs5: "" } },
                                                  [
                                                    _c("v-text-field", {
                                                      attrs: {
                                                        "hide-details": "",
                                                        label: _vm.$t("phone"),
                                                        rules:
                                                          _vm.businessType ===
                                                          "domestic"
                                                            ? [
                                                                _vm.fieldIsRequired(
                                                                  "Phone"
                                                                ),
                                                                _vm.validatePhoneBasic
                                                              ]
                                                            : []
                                                      },
                                                      model: {
                                                        value: _vm.to.phone,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.to,
                                                            "phone",
                                                            typeof $$v ===
                                                              "string"
                                                              ? $$v.trim()
                                                              : $$v
                                                          )
                                                        },
                                                        expression: "to.phone"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-flex",
                                          { attrs: { xs4: "" } },
                                          [
                                            _c("v-text-field", {
                                              attrs: {
                                                "hide-details": "",
                                                label: _vm.$t("companyName")
                                              },
                                              model: {
                                                value: _vm.to.company,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.to,
                                                    "company",
                                                    typeof $$v === "string"
                                                      ? $$v.trim()
                                                      : $$v
                                                  )
                                                },
                                                expression: "to.company"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-layout",
                                      {
                                        attrs: { "justify-space-between": "" }
                                      },
                                      [
                                        _c(
                                          "v-flex",
                                          { attrs: { xs7: "" } },
                                          [
                                            _c("v-text-field", {
                                              attrs: {
                                                "hide-details": "",
                                                label: _vm.$t("address") + " 1",
                                                rules: [
                                                  _vm.fieldIsRequired(
                                                    "Address"
                                                  ),
                                                  _vm.fieldCharLimit(
                                                    "Address1",
                                                    50
                                                  )
                                                ]
                                              },
                                              model: {
                                                value: _vm.to.address1,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.to,
                                                    "address1",
                                                    typeof $$v === "string"
                                                      ? $$v.trim()
                                                      : $$v
                                                  )
                                                },
                                                expression: "to.address1"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-flex",
                                          { attrs: { xs4: "" } },
                                          [
                                            _c("v-text-field", {
                                              attrs: {
                                                "hide-details": "",
                                                label: _vm.$t("address") + " 2",
                                                rules: [
                                                  _vm.fieldCharLimit(
                                                    "Address2",
                                                    50
                                                  )
                                                ]
                                              },
                                              model: {
                                                value: _vm.to.address2,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.to,
                                                    "address2",
                                                    typeof $$v === "string"
                                                      ? $$v.trim()
                                                      : $$v
                                                  )
                                                },
                                                expression: "to.address2"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-layout",
                                      {
                                        attrs: { "justify-space-between": "" }
                                      },
                                      [
                                        _c(
                                          "v-flex",
                                          { attrs: { xs7: "" } },
                                          [
                                            _c(
                                              "v-layout",
                                              {
                                                attrs: {
                                                  "justify-space-between": ""
                                                }
                                              },
                                              [
                                                _c(
                                                  "v-flex",
                                                  { attrs: { xs5: "" } },
                                                  [
                                                    _c("v-text-field", {
                                                      attrs: {
                                                        "hide-details": "",
                                                        label: _vm.$t("city"),
                                                        rules: [
                                                          _vm.fieldIsRequired(
                                                            "City"
                                                          )
                                                        ]
                                                      },
                                                      model: {
                                                        value: _vm.to.city,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.to,
                                                            "city",
                                                            typeof $$v ===
                                                              "string"
                                                              ? $$v.trim()
                                                              : $$v
                                                          )
                                                        },
                                                        expression: "to.city"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "v-flex",
                                                  { attrs: { xs5: "" } },
                                                  [
                                                    _vm.toStateOptions.length
                                                      ? _c("v-autocomplete", {
                                                          attrs: {
                                                            "hide-details": "",
                                                            items:
                                                              _vm.toStateOptions,
                                                            label: _vm.$t(
                                                              "state"
                                                            ),
                                                            rules:
                                                              _vm.toStateRules
                                                          },
                                                          model: {
                                                            value: _vm.to.state,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.to,
                                                                "state",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "to.state"
                                                          }
                                                        })
                                                      : _c("v-text-field", {
                                                          attrs: {
                                                            "hide-details": "",
                                                            label: _vm.$t(
                                                              "state"
                                                            ),
                                                            rules:
                                                              _vm.toStateRules
                                                          },
                                                          model: {
                                                            value: _vm.to.state,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.to,
                                                                "state",
                                                                typeof $$v ===
                                                                  "string"
                                                                  ? $$v.trim()
                                                                  : $$v
                                                              )
                                                            },
                                                            expression:
                                                              "to.state"
                                                          }
                                                        })
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-flex",
                                          { attrs: { xs4: "" } },
                                          [
                                            _c("v-text-field", {
                                              attrs: {
                                                "hide-details": "",
                                                label: _vm.$t("zipCode"),
                                                rules: [
                                                  _vm.fieldIsRequired(
                                                    "Zip code"
                                                  ),
                                                  function(v) {
                                                    return _vm.validateZipCodeBasic(
                                                      v,
                                                      _vm.to.countryCode
                                                    )
                                                  }
                                                ]
                                              },
                                              model: {
                                                value: _vm.to.zipCode,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.to,
                                                    "zipCode",
                                                    typeof $$v === "string"
                                                      ? $$v.trim()
                                                      : $$v
                                                  )
                                                },
                                                expression: "to.zipCode"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-layout",
                                      {
                                        attrs: { "justify-space-between": "" }
                                      },
                                      [
                                        _c(
                                          "v-flex",
                                          { attrs: { xs7: "" } },
                                          [
                                            _c("v-text-field", {
                                              attrs: {
                                                "hide-details": "",
                                                label: _vm.$t("email"),
                                                rules: [
                                                  function(v) {
                                                    return (
                                                      !v ||
                                                      _vm.fieldIsEmail()(v)
                                                    )
                                                  }
                                                ]
                                              },
                                              model: {
                                                value: _vm.to.email,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.to,
                                                    "email",
                                                    typeof $$v === "string"
                                                      ? $$v.trim()
                                                      : $$v
                                                  )
                                                },
                                                expression: "to.email"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-flex",
                                          { attrs: { xs4: "" } },
                                          [
                                            _c("v-autocomplete", {
                                              attrs: {
                                                "hide-details": "",
                                                items: _vm.toCountryOptions,
                                                "item-text": "name",
                                                "item-value": "value",
                                                label: _vm.$t("country"),
                                                rules: _vm.toCountryRules
                                              },
                                              model: {
                                                value: _vm.to.countryCode,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.to,
                                                    "countryCode",
                                                    $$v
                                                  )
                                                },
                                                expression: "to.countryCode"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.isSupportDangerousGoods
                      ? _c(
                          "v-layout",
                          { attrs: { row: "" } },
                          [
                            _c(
                              "v-flex",
                              [
                                _c(
                                  "v-card",
                                  { attrs: { width: "100%" } },
                                  [
                                    _c(
                                      "v-card-text",
                                      [
                                        _c("HazardousCommodities", {
                                          attrs: {
                                            dangerousGoods: _vm.dangerousGoods,
                                            offerorName: _vm.offerorName,
                                            emergencyContactNumber:
                                              _vm.emergencyContactNumber,
                                            dryIceWeight:
                                              _vm.dryIceDetail.weight,
                                            dryIceUnit: _vm.dryIceDetail.unit,
                                            filterItems: [
                                              "",
                                              "LITHIUM_BATTERY"
                                            ],
                                            isPrintSafetyDocument:
                                              _vm.isPrintSafetyDocument,
                                            signatureCode: _vm.signatureCode
                                          },
                                          on: {
                                            "update:dangerousGoods": function(
                                              $event
                                            ) {
                                              _vm.dangerousGoods = $event
                                            },
                                            "update:dangerous-goods": function(
                                              $event
                                            ) {
                                              _vm.dangerousGoods = $event
                                            },
                                            "update:offerorName": function(
                                              $event
                                            ) {
                                              _vm.offerorName = $event
                                            },
                                            "update:offeror-name": function(
                                              $event
                                            ) {
                                              _vm.offerorName = $event
                                            },
                                            "update:emergencyContactNumber": function(
                                              $event
                                            ) {
                                              _vm.emergencyContactNumber = $event
                                            },
                                            "update:emergency-contact-number": function(
                                              $event
                                            ) {
                                              _vm.emergencyContactNumber = $event
                                            },
                                            "update:dryIceWeight": function(
                                              $event
                                            ) {
                                              return _vm.$set(
                                                _vm.dryIceDetail,
                                                "weight",
                                                $event
                                              )
                                            },
                                            "update:dry-ice-weight": function(
                                              $event
                                            ) {
                                              return _vm.$set(
                                                _vm.dryIceDetail,
                                                "weight",
                                                $event
                                              )
                                            },
                                            "update:dryIceUnit": function(
                                              $event
                                            ) {
                                              return _vm.$set(
                                                _vm.dryIceDetail,
                                                "unit",
                                                $event
                                              )
                                            },
                                            "update:dry-ice-unit": function(
                                              $event
                                            ) {
                                              return _vm.$set(
                                                _vm.dryIceDetail,
                                                "unit",
                                                $event
                                              )
                                            },
                                            "update:isPrintSafetyDocument": function(
                                              $event
                                            ) {
                                              _vm.isPrintSafetyDocument = $event
                                            },
                                            "update:is-print-safety-document": function(
                                              $event
                                            ) {
                                              _vm.isPrintSafetyDocument = $event
                                            },
                                            "update:signatureCode": function(
                                              $event
                                            ) {
                                              _vm.signatureCode = $event
                                            },
                                            "update:signature-code": function(
                                              $event
                                            ) {
                                              _vm.signatureCode = $event
                                            }
                                          },
                                          model: {
                                            value: _vm.hazMatsInfo,
                                            callback: function($$v) {
                                              _vm.hazMatsInfo = $$v
                                            },
                                            expression: "hazMatsInfo"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "v-layout",
                      { attrs: { row: "" } },
                      [
                        _c(
                          "v-flex",
                          [
                            _c(
                              "v-card",
                              { attrs: { width: "100%", height: "100%" } },
                              [
                                _c(
                                  "v-card-text",
                                  [
                                    _c("v-layout", { staticClass: "title" }, [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(_vm.$t("labelDetails")) +
                                          ":\n              "
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "v-layout",
                                      {
                                        attrs: {
                                          "justify-space-between": "",
                                          "align-baseline": "",
                                          wrap: ""
                                        }
                                      },
                                      [
                                        _c(
                                          "v-flex",
                                          { attrs: { md3: "", xs5: "" } },
                                          [
                                            _c("v-autocomplete", {
                                              attrs: {
                                                "hide-details": "",
                                                items: _vm.displayShippingServices(),
                                                "item-text": "text",
                                                "item-value": "value",
                                                "menu-props": {
                                                  returnValue: "value"
                                                },
                                                rules: [
                                                  _vm.fieldIsRequired(
                                                    "service"
                                                  ),
                                                  _vm.checkShipForm()
                                                ],
                                                label: _vm.$t("shippingService")
                                              },
                                              model: {
                                                value: _vm.shippingService,
                                                callback: function($$v) {
                                                  _vm.shippingService = $$v
                                                },
                                                expression: "shippingService"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-flex",
                                          { attrs: { md2: "", xs5: "" } },
                                          [
                                            _c("v-select", {
                                              attrs: {
                                                "hide-details": "",
                                                label: _vm.$t("signature"),
                                                items: _vm.signatureOptions,
                                                "item-text": "text",
                                                "menu-props": {
                                                  returnValue: "value"
                                                }
                                              },
                                              model: {
                                                value: _vm.signature,
                                                callback: function($$v) {
                                                  _vm.signature = $$v
                                                },
                                                expression: "signature"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-flex",
                                          { attrs: { md2: "", xs5: "" } },
                                          [
                                            _c("v-select", {
                                              attrs: {
                                                "hide-details": "",
                                                disabled: !_vm.isSupportLabelStockType,
                                                label: _vm.$t("labelStockType"),
                                                items: _vm.labelStockTypes,
                                                "item-text": "text",
                                                "menu-props": {
                                                  returnValue: "value"
                                                }
                                              },
                                              model: {
                                                value: _vm.labelStockType,
                                                callback: function($$v) {
                                                  _vm.labelStockType = $$v
                                                },
                                                expression: "labelStockType"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c("v-data-table", {
                                      staticClass: "elevation-1 mt-2",
                                      attrs: {
                                        headers: _vm.packageHeaders,
                                        items: _vm.packages,
                                        "hide-actions": "",
                                        "item-key": "_key",
                                        expand: true,
                                        caption: ""
                                      },
                                      scopedSlots: _vm._u([
                                        {
                                          key: "headerCell",
                                          fn: function(props) {
                                            return [
                                              props.header.value === "action"
                                                ? _c(
                                                    "span",
                                                    [
                                                      _c(
                                                        "v-tooltip",
                                                        {
                                                          attrs: { top: "" },
                                                          scopedSlots: _vm._u(
                                                            [
                                                              {
                                                                key:
                                                                  "activator",
                                                                fn: function(
                                                                  ref
                                                                ) {
                                                                  var on =
                                                                    ref.on
                                                                  return [
                                                                    _c(
                                                                      "v-btn",
                                                                      _vm._g(
                                                                        {
                                                                          attrs: {
                                                                            color:
                                                                              "primary",
                                                                            flat:
                                                                              "",
                                                                            small:
                                                                              "",
                                                                            icon:
                                                                              ""
                                                                          },
                                                                          on: {
                                                                            click:
                                                                              _vm.addPackage
                                                                          }
                                                                        },
                                                                        on
                                                                      ),
                                                                      [
                                                                        _c(
                                                                          "v-icon",
                                                                          [
                                                                            _vm._v(
                                                                              "add"
                                                                            )
                                                                          ]
                                                                        )
                                                                      ],
                                                                      1
                                                                    )
                                                                  ]
                                                                }
                                                              }
                                                            ],
                                                            null,
                                                            true
                                                          )
                                                        },
                                                        [
                                                          _vm._v(" "),
                                                          _c("span", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "addPackage"
                                                                )
                                                              )
                                                            )
                                                          ])
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                : _c("span", [
                                                    _vm._v(
                                                      _vm._s(props.header.text)
                                                    )
                                                  ])
                                            ]
                                          }
                                        },
                                        {
                                          key: "items",
                                          fn: function(props) {
                                            return [
                                              _c(
                                                "td",
                                                {
                                                  staticClass: "text-xs-center"
                                                },
                                                [
                                                  props.index > 0
                                                    ? _c(
                                                        "v-btn",
                                                        {
                                                          attrs: {
                                                            color: "primary",
                                                            flat: "",
                                                            small: "",
                                                            icon: ""
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.removePackage(
                                                                props.index
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c("v-icon", [
                                                            _vm._v("delete")
                                                          ])
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e()
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                { staticClass: "text-xs-left" },
                                                [
                                                  _c("v-text-field", {
                                                    staticClass: "table-item",
                                                    attrs: {
                                                      "hide-details": "",
                                                      rules: [
                                                        _vm.fieldIsRequired(
                                                          "qty"
                                                        ),
                                                        _vm.fieldIsOverZero(
                                                          "qty"
                                                        ),
                                                        _vm.fieldIsInteger(
                                                          "qty"
                                                        )
                                                      ]
                                                    },
                                                    model: {
                                                      value: props.item.qty,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          props.item,
                                                          "qty",
                                                          _vm._n($$v)
                                                        )
                                                      },
                                                      expression:
                                                        "props.item.qty"
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                { staticClass: "text-xs-left" },
                                                [
                                                  _c("v-text-field", {
                                                    staticClass: "table-item",
                                                    attrs: {
                                                      "hide-details": "",
                                                      rules: [
                                                        _vm.fieldIsRequired(
                                                          "weight"
                                                        ),
                                                        _vm.fieldIsOverZero(
                                                          "weight"
                                                        )
                                                      ],
                                                      suffix: _vm.isMeasurementMetric
                                                        ? "kg"
                                                        : "Lbs"
                                                    },
                                                    model: {
                                                      value: props.item.weight,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          props.item,
                                                          "weight",
                                                          _vm._n($$v)
                                                        )
                                                      },
                                                      expression:
                                                        "props.item.weight"
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                { staticClass: "text-xs-left" },
                                                [
                                                  _c(
                                                    "v-layout",
                                                    {
                                                      attrs: {
                                                        "align-center": ""
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "v-flex",
                                                        {
                                                          staticClass: "mr-3",
                                                          attrs: { xs4: "" }
                                                        },
                                                        [
                                                          _c("v-text-field", {
                                                            staticClass:
                                                              "table-item",
                                                            attrs: {
                                                              "hide-details":
                                                                "",
                                                              suffix: _vm.isMeasurementMetric
                                                                ? "cm"
                                                                : "in",
                                                              rules: [
                                                                _vm.fieldIsRequired(
                                                                  "length"
                                                                ),
                                                                _vm.fieldIsOverZero(
                                                                  "length"
                                                                )
                                                              ]
                                                            },
                                                            model: {
                                                              value:
                                                                props.item
                                                                  .length,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.$set(
                                                                  props.item,
                                                                  "length",
                                                                  _vm._n($$v)
                                                                )
                                                              },
                                                              expression:
                                                                "props.item.length"
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "v-flex",
                                                        {
                                                          staticClass: "mr-3",
                                                          attrs: { xs4: "" }
                                                        },
                                                        [
                                                          _c("v-text-field", {
                                                            staticClass:
                                                              "table-item",
                                                            attrs: {
                                                              "hide-details":
                                                                "",
                                                              suffix: _vm.isMeasurementMetric
                                                                ? "cm"
                                                                : "in",
                                                              rules: [
                                                                _vm.fieldIsRequired(
                                                                  "width"
                                                                ),
                                                                _vm.fieldIsOverZero(
                                                                  "width"
                                                                )
                                                              ]
                                                            },
                                                            model: {
                                                              value:
                                                                props.item
                                                                  .width,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.$set(
                                                                  props.item,
                                                                  "width",
                                                                  _vm._n($$v)
                                                                )
                                                              },
                                                              expression:
                                                                "props.item.width"
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "v-flex",
                                                        { attrs: { xs4: "" } },
                                                        [
                                                          _c("v-text-field", {
                                                            staticClass:
                                                              "table-item",
                                                            attrs: {
                                                              "hide-details":
                                                                "",
                                                              suffix: _vm.isMeasurementMetric
                                                                ? "cm"
                                                                : "in",
                                                              rules: [
                                                                _vm.fieldIsRequired(
                                                                  "height"
                                                                ),
                                                                _vm.fieldIsOverZero(
                                                                  "height"
                                                                )
                                                              ]
                                                            },
                                                            model: {
                                                              value:
                                                                props.item
                                                                  .height,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.$set(
                                                                  props.item,
                                                                  "height",
                                                                  _vm._n($$v)
                                                                )
                                                              },
                                                              expression:
                                                                "props.item.height"
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "v-flex",
                                                        { attrs: { xs1: "" } },
                                                        [
                                                          _c(
                                                            "PackagingSelector",
                                                            {
                                                              attrs: {
                                                                packagings:
                                                                  _vm.packagings
                                                              },
                                                              on: {
                                                                select: function(
                                                                  item
                                                                ) {
                                                                  return _vm.onSelectPackaging(
                                                                    item,
                                                                    props.item
                                                                  )
                                                                }
                                                              }
                                                            }
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                { staticClass: "text-xs-left" },
                                                [
                                                  _c("v-text-field", {
                                                    staticClass: "table-item",
                                                    attrs: {
                                                      "hide-details": ""
                                                    },
                                                    model: {
                                                      value: props.item.memo,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          props.item,
                                                          "memo",
                                                          _vm._n($$v)
                                                        )
                                                      },
                                                      expression:
                                                        "props.item.memo"
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                { staticClass: "text-xs-left" },
                                                [
                                                  _c("v-text-field", {
                                                    staticClass: "table-item",
                                                    attrs: {
                                                      "hide-details": "",
                                                      disabled: !_vm.enableInsured,
                                                      rules: [
                                                        _vm.fieldIsNoLessThanZero(
                                                          "value"
                                                        )
                                                      ]
                                                    },
                                                    model: {
                                                      value:
                                                        props.item.insuredValue,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          props.item,
                                                          "insuredValue",
                                                          _vm._n($$v)
                                                        )
                                                      },
                                                      expression:
                                                        "props.item.insuredValue"
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _vm.isLithiumBatteryDangerousGoods
                                                ? _c(
                                                    "td",
                                                    {
                                                      staticClass:
                                                        "text-xs-center"
                                                    },
                                                    [
                                                      _c(
                                                        "v-layout",
                                                        {
                                                          staticStyle: {
                                                            cursor: "pointer"
                                                          },
                                                          attrs: {
                                                            "align-center": "",
                                                            "justify-center":
                                                              "",
                                                            id:
                                                              "expand-icon-" +
                                                              (props.item
                                                                ._key ||
                                                                props.index)
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.toggleExpand(
                                                                props
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "v-icon",
                                                            {
                                                              staticClass:
                                                                "mr-1",
                                                              attrs: {
                                                                color: "primary"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "battery_charging_full"
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c("v-icon", [
                                                            _vm._v(
                                                              "expand_more"
                                                            )
                                                          ])
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                : _vm._e()
                                            ]
                                          }
                                        },
                                        {
                                          key: "expand",
                                          fn: function(props) {
                                            return [
                                              _vm.isLithiumBatteryDangerousGoods ||
                                              (props.item.isLithiumBattery &&
                                                props.item
                                                  .lithiumBatteryOptions &&
                                                props.item.lithiumBatteryOptions
                                                  .length > 0)
                                                ? _c(
                                                    "LithiumBatteryDangerousGoods",
                                                    {
                                                      attrs: {
                                                        props: props,
                                                        lithiumBatteryOptionItems:
                                                          _vm.lithiumBatteryOptionItems
                                                      },
                                                      on: {
                                                        applyAll:
                                                          _vm.applyAllLithiumBattery
                                                      }
                                                    }
                                                  )
                                                : _vm._e()
                                            ]
                                          }
                                        }
                                      ])
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.businessType === "export"
                      ? _c(
                          "v-layout",
                          { attrs: { row: "" } },
                          [
                            _c(
                              "v-flex",
                              [
                                _c(
                                  "v-card",
                                  { attrs: { width: "100%" } },
                                  [
                                    _c(
                                      "v-card-text",
                                      [
                                        _c(
                                          "v-layout",
                                          {
                                            staticClass: "title",
                                            attrs: {
                                              "align-baseline": "",
                                              "justify-space-between": ""
                                            }
                                          },
                                          [
                                            _c(
                                              "v-flex",
                                              { attrs: { md2: "", xs4: "" } },
                                              [
                                                _vm._v(
                                                  "\n                  " +
                                                    _vm._s(
                                                      _vm.$t("commodity")
                                                    ) +
                                                    ":\n                "
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-flex",
                                              { attrs: { md4: "", xs8: "" } },
                                              [
                                                _c("v-autocomplete", {
                                                  attrs: {
                                                    "hide-details": "",
                                                    items:
                                                      _vm.commodityTemplates,
                                                    "return-object": "",
                                                    "item-text": "name",
                                                    label: _vm.$t("template")
                                                  },
                                                  on: {
                                                    change:
                                                      _vm.onSelectCommodityTemplate
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.selectedCommodityTemplate,
                                                    callback: function($$v) {
                                                      _vm.selectedCommodityTemplate = $$v
                                                    },
                                                    expression:
                                                      "selectedCommodityTemplate"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c("v-data-table", {
                                          staticClass: "elevation-1 mt-2",
                                          attrs: {
                                            headers: _vm.commodityHeaders,
                                            items: _vm.commodities,
                                            "hide-actions": "",
                                            "item-key": "index"
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "headerCell",
                                                fn: function(props) {
                                                  return [
                                                    props.header.value ===
                                                    "action"
                                                      ? _c(
                                                          "span",
                                                          [
                                                            _c(
                                                              "v-tooltip",
                                                              {
                                                                attrs: {
                                                                  top: ""
                                                                },
                                                                scopedSlots: _vm._u(
                                                                  [
                                                                    {
                                                                      key:
                                                                        "activator",
                                                                      fn: function(
                                                                        ref
                                                                      ) {
                                                                        var on =
                                                                          ref.on
                                                                        return [
                                                                          _c(
                                                                            "v-btn",
                                                                            _vm._g(
                                                                              {
                                                                                attrs: {
                                                                                  color:
                                                                                    "primary",
                                                                                  flat:
                                                                                    "",
                                                                                  small:
                                                                                    "",
                                                                                  icon:
                                                                                    ""
                                                                                },
                                                                                on: {
                                                                                  click:
                                                                                    _vm.addCommodity
                                                                                }
                                                                              },
                                                                              on
                                                                            ),
                                                                            [
                                                                              _c(
                                                                                "v-icon",
                                                                                [
                                                                                  _vm._v(
                                                                                    "add"
                                                                                  )
                                                                                ]
                                                                              )
                                                                            ],
                                                                            1
                                                                          )
                                                                        ]
                                                                      }
                                                                    }
                                                                  ],
                                                                  null,
                                                                  true
                                                                )
                                                              },
                                                              [
                                                                _vm._v(" "),
                                                                _c("span", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "addCommodity"
                                                                      )
                                                                    )
                                                                  )
                                                                ])
                                                              ]
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      : _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              props.header.text
                                                            )
                                                          )
                                                        ])
                                                  ]
                                                }
                                              },
                                              {
                                                key: "items",
                                                fn: function(props) {
                                                  return [
                                                    _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "text-xs-center"
                                                      },
                                                      [
                                                        props.index > 0
                                                          ? _c(
                                                              "v-btn",
                                                              {
                                                                attrs: {
                                                                  color:
                                                                    "primary",
                                                                  flat: "",
                                                                  small: "",
                                                                  icon: ""
                                                                },
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.removeCommodity(
                                                                      props.index
                                                                    )
                                                                  }
                                                                }
                                                              },
                                                              [
                                                                _c("v-icon", [
                                                                  _vm._v(
                                                                    "delete"
                                                                  )
                                                                ])
                                                              ],
                                                              1
                                                            )
                                                          : _vm._e()
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "text-xs-left"
                                                      },
                                                      [
                                                        _c("v-autocomplete", {
                                                          staticClass:
                                                            "table-item",
                                                          attrs: {
                                                            "hide-details": "",
                                                            items:
                                                              _vm.mergedCommoditiesList,
                                                            "item-text":
                                                              "scheduleBDescription",
                                                            "return-object": "",
                                                            value:
                                                              props.item
                                                                .selectedCommodity,
                                                            rules: [
                                                              _vm.fieldIsRequired(
                                                                _vm.$t(
                                                                  "commodity"
                                                                )
                                                              )
                                                            ]
                                                          },
                                                          on: {
                                                            change: function(
                                                              $event
                                                            ) {
                                                              return _vm.onSelectCommodity(
                                                                props.index,
                                                                $event
                                                              )
                                                            }
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "text-xs-left"
                                                      },
                                                      [
                                                        _c("v-text-field", {
                                                          staticClass:
                                                            "table-item",
                                                          attrs: {
                                                            "hide-details": "",
                                                            rules: [
                                                              _vm.fieldIsRequired(
                                                                _vm.$t(
                                                                  "description"
                                                                )
                                                              ),
                                                              _vm.fieldCharLimit(
                                                                "description",
                                                                100
                                                              )
                                                            ]
                                                          },
                                                          on: {
                                                            input: function(
                                                              $event
                                                            ) {
                                                              return _vm.onCommodityFieldInput(
                                                                props.item,
                                                                "description",
                                                                props.item
                                                                  .description
                                                              )
                                                            }
                                                          },
                                                          model: {
                                                            value:
                                                              props.item
                                                                .description,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                props.item,
                                                                "description",
                                                                typeof $$v ===
                                                                  "string"
                                                                  ? $$v.trim()
                                                                  : $$v
                                                              )
                                                            },
                                                            expression:
                                                              "props.item.description"
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "text-xs-left"
                                                      },
                                                      [
                                                        _c("v-autocomplete", {
                                                          staticClass:
                                                            "table-item",
                                                          attrs: {
                                                            "hide-details": "",
                                                            items:
                                                              _vm.countryCodeArray,
                                                            "item-text": "name",
                                                            "item-value":
                                                              "value",
                                                            rules: [
                                                              _vm.fieldIsRequired(
                                                                _vm.$t(
                                                                  "countryOfOrigin"
                                                                )
                                                              )
                                                            ]
                                                          },
                                                          model: {
                                                            value:
                                                              props.item
                                                                .countryOfOrigin,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                props.item,
                                                                "countryOfOrigin",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "props.item.countryOfOrigin"
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "text-xs-left"
                                                      },
                                                      [
                                                        _c("v-text-field", {
                                                          staticClass:
                                                            "table-item",
                                                          attrs: {
                                                            "hide-details": "",
                                                            rules: [
                                                              _vm.fieldIsRequired(
                                                                _vm.$t("hsCode")
                                                              ),
                                                              _vm.validateHsCode
                                                            ]
                                                          },
                                                          model: {
                                                            value:
                                                              props.item
                                                                .harmonizedCode,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                props.item,
                                                                "harmonizedCode",
                                                                typeof $$v ===
                                                                  "string"
                                                                  ? $$v.trim()
                                                                  : $$v
                                                              )
                                                            },
                                                            expression:
                                                              "props.item.harmonizedCode"
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "text-xs-left"
                                                      },
                                                      [
                                                        _c("v-text-field", {
                                                          staticClass:
                                                            "table-item",
                                                          attrs: {
                                                            "hide-details": "",
                                                            rules: [
                                                              _vm.fieldIsRequired(
                                                                _vm.$t("qty")
                                                              ),
                                                              _vm.fieldIsInteger(
                                                                _vm.$t("qty")
                                                              ),
                                                              _vm.fieldIsOverZero(
                                                                _vm.$t("qty")
                                                              )
                                                            ]
                                                          },
                                                          on: {
                                                            input: function(
                                                              $event
                                                            ) {
                                                              return _vm.onCommodityFieldInput(
                                                                props.item,
                                                                "quantity",
                                                                props.item
                                                                  .quantity
                                                              )
                                                            }
                                                          },
                                                          model: {
                                                            value:
                                                              props.item
                                                                .quantity,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                props.item,
                                                                "quantity",
                                                                _vm._n($$v)
                                                              )
                                                            },
                                                            expression:
                                                              "props.item.quantity"
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "text-xs-left"
                                                      },
                                                      [
                                                        _c("v-text-field", {
                                                          staticClass:
                                                            "table-item",
                                                          attrs: {
                                                            "hide-details": "",
                                                            rules: [
                                                              _vm.fieldIsRequired(
                                                                _vm.$t("unit")
                                                              )
                                                            ]
                                                          },
                                                          model: {
                                                            value:
                                                              props.item.unit,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                props.item,
                                                                "unit",
                                                                typeof $$v ===
                                                                  "string"
                                                                  ? $$v.trim()
                                                                  : $$v
                                                              )
                                                            },
                                                            expression:
                                                              "props.item.unit"
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "text-xs-left"
                                                      },
                                                      [
                                                        _c("v-text-field", {
                                                          staticClass:
                                                            "table-item",
                                                          attrs: {
                                                            "hide-details": "",
                                                            rules: [
                                                              _vm.fieldIsNoLessThanZero(
                                                                _vm.$t("price")
                                                              )
                                                            ]
                                                          },
                                                          on: {
                                                            input: function(
                                                              $event
                                                            ) {
                                                              return _vm.onCommodityFieldInput(
                                                                props.item,
                                                                "price",
                                                                props.item.price
                                                              )
                                                            }
                                                          },
                                                          model: {
                                                            value:
                                                              props.item.price,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                props.item,
                                                                "price",
                                                                _vm._n($$v)
                                                              )
                                                            },
                                                            expression:
                                                              "props.item.price"
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "text-xs-left"
                                                      },
                                                      [
                                                        _c("v-text-field", {
                                                          staticClass:
                                                            "table-item",
                                                          attrs: {
                                                            "hide-details": "",
                                                            prefix: "$",
                                                            disabled: true,
                                                            value: _vm.computeCustomsValue(
                                                              {
                                                                quantity:
                                                                  props.item
                                                                    .quantity,
                                                                price:
                                                                  props.item
                                                                    .price
                                                              }
                                                            ),
                                                            rules: [
                                                              _vm.fieldIsNoLessThanZero(
                                                                _vm.$t(
                                                                  "totalCustomsValue($)"
                                                                )
                                                              )
                                                            ]
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "text-xs-left"
                                                      },
                                                      [
                                                        _c("v-text-field", {
                                                          staticClass:
                                                            "table-item",
                                                          attrs: {
                                                            "hide-details": "",
                                                            rules: [
                                                              _vm.fieldIsRequired(
                                                                _vm.$t("weight")
                                                              ),
                                                              _vm.fieldIsOverZero(
                                                                _vm.$t("weight")
                                                              )
                                                            ]
                                                          },
                                                          model: {
                                                            value:
                                                              props.item
                                                                .commodityWeight,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                props.item,
                                                                "commodityWeight",
                                                                _vm._n($$v)
                                                              )
                                                            },
                                                            expression:
                                                              "props.item.commodityWeight"
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    )
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            false,
                                            2781938864
                                          )
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e()
                  ],
                  1
                )
              ]
            },
            proxy: true
          }
        ]),
        model: {
          value: _vm.value,
          callback: function($$v) {
            _vm.value = $$v
          },
          expression: "value"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3d866939", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d866939","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LabelTemplatePopupForLabel.vue
// module id = null
// module chunks = 